import React, { useState } from 'react'
import { Box, Button, useMediaQuery } from '@mui/material'
import { RestrictedAccessDialog } from '../../../components/shared/Dialogs'
import { useTheme } from '@mui/material/styles'
import { Link as RouteLink } from 'react-router-dom'

const StartFreeTrial = () => {
  const theme = useTheme()
  const mdMatched = useMediaQuery(theme.breakpoints.down('md'))

  const [restrictedAccessDialog, setRestrictedAccessDialog] = useState<boolean>(false)

  const handleClose = () => {
    setRestrictedAccessDialog(false)
  }

  return (
    <>
      <Box
        sx={{
          width: 1,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: mdMatched ? 'center' : 'flex-start',
          my: mdMatched ? 3 : 1,
        }}
      >
        <Button variant='contained' component={RouteLink} to='/auth/register'>
          Access Tool
        </Button>
      </Box>
      <RestrictedAccessDialog open={restrictedAccessDialog} onClose={handleClose} />
    </>
  )
}

export default StartFreeTrial
